import React from 'react'
import { RichTextRenderer } from '../../../lib/components'
import { CMSOpportunityDetailsFactSheetType } from '../../../lib/types'
import { CmsSectionText } from './cms-section-text-content'

const CMSFactSheet = ({ factSheet }: { factSheet?: CMSOpportunityDetailsFactSheetType }) => {
  return (
    <section data-testid='cms-fact-sheet-content'>
      <section className='investment-reason'>
        {factSheet?.facts?.map((fact, idx) => (
          <section className='flex' key={idx}>
            <section className='flex-1'>
              <img src={fact?.factTextImage} alt={`Fact Image ${idx + 1}`} />
            </section>
            <section className='flex flex-justify-center flex-direction-col flex-5'>
              <h3 className='headings-blue-charlie'>{fact?.factTextPrimary}</h3>
              <p className='basic'>{fact?.factTextSecondary}</p>
            </section>
          </section>
        ))}
      </section>
      {(factSheet?.images?.length ?? 0) > 0 && (
        <section className='opportunity-cms-section-image-list' data-testid='cms-fact-sheet-images'>
          {factSheet?.images?.map((url, idx) => (
            <img
              src={url}
              alt={`Image ${idx + 1}`}
              className={`width-100percent ${idx === 0 ? '' : 'mt-12'}`}
              key={`Fact Sheet Image ${idx + 1}`}
            />
          ))}
        </section>
      )}
      {factSheet?.sectionText?.length ? (
        <CmsSectionText dataTestId='cms-fact-sheet-text'>
          <RichTextRenderer content={factSheet.sectionText} variant='opportunity-details' />
        </CmsSectionText>
      ) : null}
    </section>
  )
}

export { CMSFactSheet }
